import React from "react";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          height: "90vh",
          overflowY: "auto",
          padding: "40px",
          backgroundColor: "#111",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(255, 255, 255, 0.1)",
        }}
        className="scrollable-box"
      >
        <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
          Terms and Conditions
        </h1>
        <p>
          Please read these Terms and Conditions carefully before using our
          services.
        </p>
        <ul>
          <li>
            Acceptance of Terms: By accessing our services, you agree to these
            terms.
          </li>
          <li>
            Eligibility: You must be at least 18 years old to use our services.
          </li>
          <li>
            Account Responsibility: You are responsible for maintaining the
            confidentiality of your account.
          </li>
          <li>
            Prohibited Use: You may not use our platform for unlawful purposes.
          </li>
          <li>
            Service Availability: We do not guarantee uninterrupted access to
            our services.
          </li>
          <li>
            Intellectual Property: All content is owned by us and protected by
            copyright laws.
          </li>
          <li>
            User Content: Any content you submit must not violate third-party
            rights.
          </li>
          <li>
            Privacy Policy: Your use of our services is also governed by our
            Privacy Policy.
          </li>
          <li>
            Payment Terms: All payments must be made according to our stated
            policies.
          </li>
          <li>Refund Policy: Refunds are subject to our sole discretion.</li>
          <li>
            Third-Party Links: We are not responsible for content on third-party
            sites.
          </li>
          <li>
            Termination: We may suspend or terminate your access without prior
            notice.
          </li>
          <li>
            Limitation of Liability: We are not liable for indirect or
            consequential damages.
          </li>
          <li>
            Disclaimer of Warranties: Services are provided "as is" without
            warranties.
          </li>
          <li>
            Indemnification: You agree to indemnify us against any claims
            arising from your use.
          </li>
          <li>
            Governing Law: These terms are governed by the laws of your
            jurisdiction.
          </li>
          <li>
            Dispute Resolution: Any disputes will be resolved through
            arbitration.
          </li>
          <li>
            Changes to Terms: We may update these terms at any time without
            prior notice.
          </li>
          <li>
            Severability: If any provision is found invalid, the rest remain in
            effect.
          </li>
          <li>
            Entire Agreement: These terms constitute the entire agreement
            between parties.
          </li>
          <li>
            Contact Information: You may contact us for any queries regarding
            these terms.
          </li>
          <li>
            Marketing Communications: You consent to receive marketing unless
            you opt out.
          </li>
          <li>Cookies: We may use cookies to enhance your experience.</li>
          <li>
            Data Security: We implement security measures but cannot guarantee
            absolute safety.
          </li>
          <li>
            Account Suspension: We may suspend accounts suspected of fraudulent
            activity.
          </li>
          <li>
            Content Moderation: We reserve the right to remove inappropriate
            content.
          </li>
          <li>
            License: You are granted a limited license to use our services.
          </li>
          <li>
            Force Majeure: We are not responsible for delays due to unforeseen
            circumstances.
          </li>
          <li>
            Non-transferability: Your account is non-transferable without our
            consent.
          </li>
          <li>
            Updates: We may modify or discontinue features of our service.
          </li>
          <li>
            Accessibility: We strive for accessibility but do not guarantee
            compatibility.
          </li>
          <li>
            Third-Party Services: Use of third-party integrations is at your own
            risk.
          </li>
          <li>Beta Features: Features labeled as “beta” may be unstable.</li>
          <li>
            Feedback: Any feedback you provide may be used without obligation.
          </li>
          <li>
            Monitoring: We may monitor use of our services for compliance.
          </li>
          <li>
            Multiple Accounts: You may not create multiple accounts for abusive
            purposes.
          </li>
          <li>
            Violation: Violation of these terms may result in permanent ban.
          </li>
          <li>
            Taxes: You are responsible for applicable taxes related to your use.
          </li>
          <li>Support: Support is provided on a best-effort basis.</li>
          <li>
            Survival: Certain provisions will survive termination of this
            agreement.
          </li>
        </ul>
      </div>

      {/* Add CSS for custom scrollbar */}
      <style>{`
        .scrollable-box::-webkit-scrollbar {
          width: 8px;
        }
        .scrollable-box::-webkit-scrollbar-track {
          background: #111;
        }
        .scrollable-box::-webkit-scrollbar-thumb {
          background-color: #555;
          border-radius: 4px;
        }
        .scrollable-box::-webkit-scrollbar-thumb:hover {
          background-color: #888;
        }
      `}</style>
    </div>
  );
};

export default TermsAndConditions;
